
import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig, { colors } from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid: 0,          // From Auth
  displayName: "John Doe", // From Auth
  about: "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL: require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status: "online",
  userRole: "retailer",
  organisations: [],
  activeCampaignId: [],
  activeOrganisationId: 0,
  activeStrategyId: 0,
  campaigns: [],
  strategies: [],
  isSystemAdmin: false,
  language: 'en'
}

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  const userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ? userInfoLocalStorage[key] : userDefaults[key]
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = " -webkit- -moz- -o- -ms- ".split(" ")
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if ("ontouchstart" in window || window.DocumentTouch) {
    return true
  }

  // include the "heartz" as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("")
  return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser: getUserInfo(),
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  is_touch_device: is_touch_device(),
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  refCodes: {
    languages: [
      { description: 'English', code: 'en' },
      { description: 'German', code: 'de' },
      { description: 'Dutch', code: 'nl' }
    ],
    roles: [
      { description: 'Administrator', id: 1 },
      { description: 'User', id: 2 },
      { description: 'Retailer', id: 3 }
    ],
    reportPeriods: [
      { description: 'None', id: 0 },
      { description: 'Monthly', id: 1 },
      { description: 'Weekly', id: 2 },
      { description: 'Monthly', id: 3 }
    ],
    jobFeedTypes: [
      { description: 'Indeed', id: 1 },
    ],
    subscriptionStates: [
      "Created",
      "Running",
      "PauseRequested",
      "Paused",
      "ResumeRequested",
      "Finished"
    ],
    fieldTypes: [
      { id: "Text", description: "Text" },
      { id: "Html", description: "Html" },
      { id: "Boolean", description: "Yes/No" },
      { id: "Number", description: "Number" },
      { id: "DateTime", description: "DateTime" },
      { id: "Image", description: "Image" },
      { id: "ImageList", description: "ImageList" },
    ],
    imageTypes: [
      { description: 'Logo', id: 1 },
      { description: 'Background', id: 2 },
    ],
    strategyTypes: [
      { description: 'NoStrategies', id: 1 },
      { description: 'Retailers', id: 2 },
      { description: 'Jobs', id: 3 },
      { description: 'Products', id: 4 },
      { description: 'Articles', id: 5 },],
    products: [
      { description: 'DailyBudget', id: 1 },
      { description: 'Banners', id: 2 },
      { description: 'Discount', id: 3 },
      { description: 'Setup', id: 4 },
      { description: 'Other', id: 9 },],
    orderStates: [
      { description: 'Created', id: "Created" },
      { description: 'Proposal', id: "Proposal" },
      { description: 'Confirmed', id: "Confirmed" },
      { description: 'Canceled', id: "Canceled" },
      { description: 'Archived', id: "Archived" }
    ]
  }
}

export default state
